<template>
  <div class="card border-1 rounded-0" style="border-style: dashed">
    <input type="file" :name="name" @change="onChange" :accept="accept"/>
    <template v-if="canShowPreviewImage">
      <img
        :src="previewImage"
        class="img-fluid"
        :height="height"
      />
      <input v-if="fileName" type="text" class="form-control bg-white" :value="fileName" readonly/>
    </template>
    <div v-else class="card-body text-center line-height-2 text-loosen-2 text-black-30">
      <i data-feather="camera"></i><br>
      {{ placeholder }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: 'image',
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    maxSize: {
      type: Number,
      default: 3 // megabytes
    },
    disablePreview: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '點擊或拖曳圖片到此'
    },
    width: Number,
    height: Number,
    restrict: Boolean,
  },

  data() {
    return {
      file: null,
      preview: null,
      visiblePreview: false
    };
  },

  computed: {
    canShowPreviewImage() {
      return this.previewImage && !this.disablePreview;
    },

    previewImage() {
      return this.preview || this.src;
    },

    fileName() {
      return this.file ? this.file.name : '';
    },
  },

  methods: {
    onChange(e) {
      const files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        return;
      }

      const file = files[0];
      const size = file.size && (file.size / Math.pow(1000, 2));

      // check file max size
      if (size > this.maxSize) {
        // this.$emit('size-exceeded', size);
        alert(`圖片為 ${size}Mb 超過最大限制 ${this.maxSize}Mb！`);
        return;
      }

      if (!window.FileReader) {
        return;
      }

      const reader = new FileReader();

      reader.onload = e => {
        const dataURI = e.target.result;
        let image = new Image();
        image.src = dataURI;
        image.onload = () => {
          if (this.restrict && (this.width != image.width || this.height != image.height)) {
            alert(`上傳圖片的尺寸為 ${image.width}x${image.height} 不符合規範的 ${this.width}x${this.height}`);
            return;
          }

          // update file
          this.file = file;
          this.$emit('file', file, this.name);

          if (dataURI) {
            this.$emit('load', dataURI);
            this.preview = dataURI;
          }
        };


      };

      // read blob url from file data
      reader.readAsDataURL(file);
    }
  },
};
</script>

<style lang="scss" scoped>
.hint {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

input[type="file"] {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  overflow: hidden;
  outline: none;
  cursor: pointer;
}

</style>
